import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useTranslation } from 'react-i18next';
import './styleHeader.css'
import "bootstrap/dist/css/bootstrap.min.css"
import ModalLanguage from "./Modal";
function Header({ language, setLanguage }) {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isHomePage, setIsHomePage] = useState(true);
  const [headerBackground, setHeaderBackground] = useState('transparent');
  //const [isLanguageModalOpen , setIsLanguageModalOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      let scrollPosition = window.scrollY;
      if (scrollPosition > 100) {
        setHeaderBackground('#147ca6');
      } else {
        setHeaderBackground('transparent');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChangeLanguage = (selectedLanguage) => {
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    // setIsLanguageModalOpen(false)
  };

  const handleMenuToggle = () => {

    setMenuOpen(!menuOpen);
    document.querySelector('.navbar .menu').classList.toggle('active');


  };


  const handleHomePage = (name) => {
    if (name === 'home') {
      setHeaderBackground('#147ca6');
      setIsHomePage(true);
    } else {
      setHeaderBackground('transparent');
      setIsHomePage(false);
    }
    setMenuOpen(false)
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={`navbar navbar-expand-lg navbar-expand{-sm|-md|-lg|-xl|-xxl} fixed-top ${isHomePage ? 'sticky' : ''}`}
      style={{ backgroundColor: headerBackground }}
    >
      <Container className="max-width">
        
        <Navbar.Brand href="#home">
          <img src="logo1.jpg" alt="Logo"  />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="navbarScroll" data-bs-toggle="collapse" data-bs-target="#navbarScroll"

          onClick={handleMenuToggle}
        />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className={`menu ${menuOpen ? 'show' : ''}`}
        >
          <Nav className="menu">
            <Nav.Link href="#about" onClick={() => handleHomePage('about')} className="menu-btn">
              {t('menu.about')}
            </Nav.Link>
            <Nav.Link href="#services" onClick={() => handleHomePage('services')} className="menu-btn">
              {t('menu.services')}
            </Nav.Link>
            <NavDropdown title={t('menu.activities')} id="basic-nav-dropdown" className="menu-btn">
              <NavDropdown.Item onClick={() => handleHomePage('activites')} href="#activites" className="menu-btn">
                {t('activities.sous-title1')}
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleHomePage('activites')} href="#activites" className="menu-btn">
                PME
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleHomePage('activites')} href="#activites" className="menu-btn">
                Retail
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleHomePage('activites')} href="#activites" className="menu-btn">
                Telecommunication
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#contact" className="menu-btn" onClick={() => handleHomePage('contact')}>{t('menu.contact')}</Nav.Link>
            <NavDropdown title={t('menu.translate')} id="basic-nav-dropdown">
              <NavDropdown.Item as="button" onClick={() => handleChangeLanguage('en')} value="en" className="menu-btn">
                {t('english')}
              </NavDropdown.Item>
              <NavDropdown.Item as="button" onClick={() => handleChangeLanguage('fr')} className="menu-btn">
                {t('french')}
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
